// ============ English ============
// كل ملفات اللغات (en, ar, ru, de, fr, es, it, he, zh) ليها نفس الشكل بالظبط. لو ضفت مفتاح هنا ضيفه في الباقي.
const en = {
  brand: "HELMAX",
  brandFull: "HELMAX Real Estate",

  nav: {
    links: {
      home: "Home",
      about: "About us",
      projects: "Projects",
      developers: "Developers",
      blogs: "Blog",
      contact: "Contact",
      guide: "Off-plan guide",
    },
    cta: "Book a viewing",
    language: "Language",
    menu: "Menu",
  },

  hero: {
    eyebrow: "Off-plan residences in Dubai",
    lines: ["Own the", "skyline of", "tomorrow"],
    sub: "Handpicked off-plan homes in Dubai's most sought-after addresses, secured before the first stone is laid.",
    primary: "View projects",
    secondary: "Book a private viewing",
    card: {
      title: "Why invest in Dubai",
      items: [
        { k: "0%", v: "Personal income tax" },
        { k: "Freehold", v: "Ownership for foreign investors" },
        { k: "Flexible", v: "Off-plan payment plans" },
      ],
    },
    scroll: "Scroll",
  },

  projects: {
    label: "Projects",
    title: ["Addresses worth", "waiting for"],
    sub: "A curated selection of off-plan developments, each chosen for its location, developer track record and long-term value.",
    from: "From",
    handover: "Handover",
    view: "View project",
    onRequest: "On request",
    soon: "Announced soon",
    quarters: ["Q1", "Q2", "Q3", "Q4"],
    cta: {
      title: "Looking for something specific?",
      text: "Tell us your budget and preferred area, and we will shortlist the right projects for you.",
      button: "Talk to an advisor",
    },
  },

  blogs: {
    label: "Insights",
    title: ["Notes from", "the market"],
    sub: "Practical guides and market notes to help you buy off-plan in Dubai with confidence.",
    min: "min read",
    all: "View all articles",
    read: "Read article",
    viewLabel: "Choose layout",
    views: { list: "List", cards: "Cards" },
    categories: { investing: "Investing", guides: "Guides", market: "Market", buying: "Buying", finance: "Finance" },
    items: [
      { title: "Off-plan or ready: which suits your Dubai investment?", excerpt: "A clear comparison of cost, risk, timeline and returns, so you can choose the route that fits your goals." },
      { title: "How off-plan payment plans really work", excerpt: "From booking fee to handover: what you pay, when you pay it, and what to ask before you reserve." },
      { title: "Five Dubai areas buyers are watching", excerpt: "Where new launches are clustering, what is driving demand, and how to read an area before you commit." },
      { title: "What to check in an off-plan contract", excerpt: "The clauses, approvals and escrow details worth reading twice before you sign." },
      { title: "How escrow accounts protect your off-plan payments", excerpt: "Where your money is held, when it is released to the developer, and how to confirm the account is registered." },
      { title: "A first-time buyer's checklist for Dubai off-plan", excerpt: "From setting a budget to choosing a developer, the steps to follow before you pay a booking fee." },
      { title: "How to compare rental yields across Dubai areas", excerpt: "What gross and net yield really mean, and the costs that quietly reduce your return." },
      { title: "Mortgages for non-resident buyers: what to expect", excerpt: "How lenders assess non-residents, typical down payment ranges, and when to arrange financing for an off-plan purchase." },
      { title: "Reading a developer's track record before you buy", excerpt: "Delivery history, handover dates versus promises, and the public records worth checking." },
      { title: "Can you resell an off-plan unit before handover?", excerpt: "How assignment works, the conditions developers set, and what it means for your exit plan." },
    ],
  },

  // آراء حقيقية من صفحة HELMAX على جوجل ماب
  testimonials: {
    label: "Testimonials",
    title: ["In their", "own words"],
    sub: "What clients say about working with HELMAX, from our reviews on Google.",
    source: "Google review",
    role: "HELMAX client",
    translated: "",
    more: "Read all reviews on Google",
    prev: "Previous",
    next: "Next",
    items: [
      "Very professional team, especially Razan. She helped me so much throughout the entire process. She is kind, patient and truly cares about her clients. She explained everything clearly and made sure I felt comfortable every step of the way. She's truly the best in this field.",
      "Excellent experience with the real estate company. Honest, fast and professional. Highly recommended.",
      "My experience with the real estate company was excellent. Professional and fast service with great attention to detail. The team was helpful and supported me every step of the way. Highly recommended.",
      "I have had a good experience with them for two years, especially after the sale.",
    ],
  },

  developers: {
    label: "Our developers",
    title: ["Partners behind", "every address"],
    sub: "We work only with developers whose delivery record and build quality we have verified.",
    projects: "projects",
    since: "Since",
    note: "Want the full delivery record of a developer? Our advisors share it before you reserve.",
    cta: "Talk to an advisor",
  },

  about: {
    label: "About us",
    title: ["Dubai is built", "years before", "it is seen."],
    lead: "HELMAX Real Estate guides investors and families into Dubai's finest off-plan developments, from waterfront towers to private villa communities. We negotiate early access, verify every developer, and stay beside you until the keys are in your hand.",
    body: "Every project we offer is chosen for its location, build quality and long-term value, so your investment gains meaning long before handover.",
    cta: "Our story",
    stats: [
      { value: 12, suffix: "+", label: "Years of experience" },
      { value: 480, suffix: "+", label: "Homes delivered" },
      { value: 35, suffix: "+", label: "Partner developers" },
      { value: 98, suffix: "%", label: "Client satisfaction" },
    ],
  },

  contact: {
    label: "Contact",
    title: ["Let's start", "the conversation"],
    sub: "Tell us what you are looking for and one of our advisors will reach out within hours.",
    interests: ["Buy", "Sell", "Invest", "Rent"],
    form: {
      interest: "I am interested in",
      name: "Name",
      phone: "Phone",
      email: "Email (optional)",
      message: "Your message (optional)",
      search: "Search country or code",
      noResults: "No country found",
      note: "Sending opens a WhatsApp chat with your message ready.",
      submit: "Send request",
    },
    info: {
      phone: "Phone",
      email: "Email",
      address: "Address",
      addressValue: "Office 1141, Tamani Arts Offices, Al Asayel St, Business Bay, Dubai, UAE",
      hours: "Hours",
      hoursValue: "Mon – Sat · 12 PM – 10 PM",
      closed: "Sunday closed",
    },
    done: {
      title: "Thank you",
      text: "We have your request and an advisor will be in touch shortly.",
      again: "Send another request",
    },
  },

  footer: {
    tagline: "Handpicked off-plan homes in Dubai, guided from the first viewing to the day you receive your keys.",
    follow: "Follow us",
    explore: "Explore",
    contact: "Contact",
    languages: "Languages",
    rights: "All rights reserved.",
    top: "Back to top",
  },

  aboutPage: {
    back: "Back to home",
    values: {
      label: "What we stand for",
      title: "How we work",
      items: [
        { title: "Verified developers", text: "We work only with developers whose delivery record and build quality we have checked ourselves." },
        { title: "Early access", text: "We negotiate early access to launches so you can choose before the best units are gone." },
        { title: "Clear numbers", text: "Prices, payment plans and handover dates are explained plainly, with no pressure to decide." },
        { title: "Beside you to the keys", text: "From the first viewing to the day you receive your keys, the same advisor stays with you." },
      ],
    },
    steps: {
      label: "Your journey",
      title: "From first call to keys",
      items: [
        { title: "Tell us your goal", text: "Your budget, preferred area and whether you are buying to live or to invest." },
        { title: "Receive a shortlist", text: "We select the projects that fit, with developer record, payment plan and handover date." },
        { title: "View and compare", text: "A private viewing arranged around your schedule, in person or online." },
        { title: "Reserve with confidence", text: "We walk you through the contract, payments and escrow details before you sign." },
        { title: "Follow to handover", text: "We keep you updated on construction progress until your home is ready." },
      ],
    },
    cta: {
      title: "Ready to start?",
      text: "Tell us what you are looking for and one of our advisors will reach out within hours.",
      button: "Talk to an advisor",
    },
  },

  blogsPage: {
    all: "All",
    featured: "Featured",
    empty: "No articles in this category yet.",
    back: "Back to home",
    ctaTitle: "Have a question about buying off-plan?",
    ctaText: "Tell us what you are looking for and one of our advisors will reach out within hours.",
    ctaButton: "Talk to an advisor",
  },

  contactPage: {
    back: "Back to home",
    required: "Please enter your name and phone number.",
    msgIntro: "Hello HELMAX, I would like to talk to an advisor.",
    msgInterest: "Interested in",
    msgName: "Name",
    msgPhone: "Phone",
    msgEmail: "Email",
    msgNote: "Message",
    channelsLabel: "Reach us directly",
    whatsapp: "WhatsApp",
    call: "Call",
    directions: "Open in Google Maps",
    mapTitle: "HELMAX Real Estate on the map",
    faqLabel: "Before you write",
    faqTitle: "Common questions",
    faq: [
      { q: "What are your working hours?", a: "We are open Monday to Saturday from 12 PM to 10 PM (Dubai time). The office is closed on Sunday, but you can send us a WhatsApp message at any time." },
      { q: "Where is the HELMAX office?", a: "Office 1141, Tamani Arts Offices, Al Asayel Street, Business Bay, Dubai. You can open our location in Google Maps from this page." },
      { q: "How soon will an advisor contact me?", a: "Within working hours we usually reach out within a few hours of receiving your request." },
      { q: "Does it cost anything to speak with an advisor?", a: "No. The consultation, shortlist and private viewing are free of charge." },
      { q: "Can I enquire from outside the UAE?", a: "Yes. We guide international buyers by phone, video call and WhatsApp, and can arrange a viewing when you visit." },
      { q: "What should I prepare for the first call?", a: "Your approximate budget, the areas you like, and whether you are buying to live in or to invest." },
    ],
  },

  devPage: {
    view: "View profile",
    back: "All developers",
    founded: "Founded",
    delivered: "Projects launched",
    hq: "Headquarters",
    focus: "Focus",
    website: "Official website",
    recentLabel: "Latest projects",
    recentTitle: ["Five recent", "launches"],
    recentSub: "The most recent projects from this developer, from new launches to homes already delivered.",
    from: "From",
    handover: "Handover",
    quarters: ["Q1", "Q2", "Q3", "Q4"],
    onRequest: "On request",
    soon: "Announced soon",
    status: { launch: "New launch", underway: "Under construction", completed: "Delivered" },
    enquire: "Enquire about",
    ctaTitle: "Interested in {name}?",
    ctaText: "Our advisors can share the full delivery record, payment plans and availability before you reserve.",
    ctaButton: "Talk to an advisor",
    prev: "Previous developer",
    next: "Next developer",
    notFound: {
      title: "Developer not found",
      text: "We could not find this developer. Browse our partners from the home page.",
      back: "Back to developers",
    },
  },

  projectsPage: {
    label: "Projects",
    title: ["Find your", "next address"],
    sub: "Every off-plan project we currently offer, from new launches to homes already rising. Filter by type, status or developer.",
    stats: ["Projects", "Developers", "Areas"],
    type: "Type",
    status: "Status",
    developer: "Developer",
    sort: "Sort by",
    all: "All",
    allDevs: "All developers",
    sorts: { default: "Featured", priceAsc: "Price: low to high", priceDesc: "Price: high to low", handover: "Handover: soonest" },
    statuses: { launch: "New launch", underway: "Under construction", completed: "Completed" },
    from: "From",
    handover: "Handover",
    enquire: "Enquire",
    more: "Show more",
    reset: "Clear filters",
    onRequest: "On request",
    soon: "Announced soon",
    quarters: ["Q1", "Q2", "Q3", "Q4"],
    count: (n, f) => `${f} ${n === 1 ? "project" : "projects"}`,
    emptyTitle: "No projects match these filters",
    emptyText: "Try removing a filter, or tell us what you need and we will find it for you.",
    ctaTitle: "Can't see the right project?",
    ctaText: "Tell us your budget and preferred area. Our advisors will shortlist projects that fit, including ones not listed here.",
    ctaButton: "Talk to an advisor",
  },

  fab: {
    "group": "Quick contact",
    "whatsapp": "Chat on WhatsApp",
    "call": "Call us",
    "top": "Back to top",
    "back": "Go back",
    "waMessage": "Hello, I would like to ask about your off-plan projects."
  },

  howItWorks: {
    "label": "How it works",
    "title": [
      "Buying off-plan,",
      "step by step"
    ],
    "sub": "From choosing a project to receiving your title deed, this is how an off-plan purchase works in Dubai.",
    "cta": "Read the full guide"
  },

  listWithUs: {
    "label": "Own an off-plan unit?",
    "title": [
      "List your unit",
      "with us"
    ],
    "text": "Already own an off-plan unit and want to sell or assign it? Contact our team and we will help you find the right buyer.",
    "whatsapp": "WhatsApp",
    "call": "Call",
    "email": "Email",
    "waMessage": "Hello HELMAX, I would like to list my off-plan unit."
  },

  awards: {
    label: "Recognition",
    title: ["Awards &", "recognition"],
    sub: "Awards and recognition HELMAX has received from developers and Dubai's real estate industry.",
    prev: "Previous",
    next: "Next",
    open: "Enlarge",
    close: "Close",
    slide: "Award {n} of {total}",
  },

  guidePage: {
    "label": "Buyer's guide",
    "title": [
      "How to buy",
      "off-plan in Dubai"
    ],
    "intro": "A short, clear guide to every stage of buying off-plan property in Dubai: the steps, the costs and what protects your money.",
    "stepsLabel": "The steps",
    "stepsTitle": "From reservation to title deed",
    "steps": [
      {
        "title": "Choose the project and check the developer",
        "text": "Shortlist projects that fit your budget and goals, then confirm the developer's delivery record and that the project is registered with RERA with an approved escrow account."
      },
      {
        "title": "Reserve the unit",
        "text": "Pay the booking amount set by the developer (often 10–20% of the price) and sign the reservation form to hold your unit."
      },
      {
        "title": "Sign the Sales & Purchase Agreement",
        "text": "The SPA sets the price, payment plan, handover date and specifications. Read it carefully before you sign."
      },
      {
        "title": "Register on Oqood",
        "text": "The developer registers your purchase on Oqood, the Dubai Land Department's interim register for off-plan property, and you pay the DLD registration fee."
      },
      {
        "title": "Pay by milestones",
        "text": "Instalments follow the payment plan and go into the project's escrow account. You can follow construction progress on the Dubai REST app."
      },
      {
        "title": "Handover and title deed",
        "text": "At completion you inspect the unit (snagging), settle the final payment and receive the keys and your title deed."
      }
    ],
    "costsLabel": "Costs",
    "costsTitle": "What you pay on top of the price",
    "costs": [
      {
        "k": "DLD registration fee",
        "v": "4% of the purchase price (some developers cover part or all of it as an incentive)"
      },
      {
        "k": "Oqood and admin fees",
        "v": "Fixed fees charged when the sale is registered; they vary by project"
      },
      {
        "k": "Booking amount",
        "v": "Usually 10–20% of the price, set by each developer"
      },
      {
        "k": "Service charges",
        "v": "Paid every year after handover for building and community upkeep"
      }
    ],
    "protectLabel": "Buyer protection",
    "protectTitle": "What protects your money",
    "protect": [
      {
        "title": "Escrow accounts",
        "text": "Under Dubai Law No. 8 of 2007, buyer payments for off-plan units go into an escrow account dedicated to that project and are released to the developer as construction progresses."
      },
      {
        "title": "Official registration",
        "text": "Oqood registration records your purchase with the Dubai Land Department before the title deed is issued."
      },
      {
        "title": "Progress you can check",
        "text": "The Dubai REST app lets you follow your project's registration and construction status."
      }
    ],
    "faqTitle": "Off-plan questions, answered",
    "faq": [
      {
        "q": "Can foreigners buy off-plan property in Dubai?",
        "a": "Yes. Foreign buyers can own property outright (freehold) in Dubai's designated freehold areas, which include most new off-plan communities."
      },
      {
        "q": "How much do I need to pay upfront?",
        "a": "Typically the developer's booking amount (often 10–20%) plus the 4% DLD registration fee and admin fees. The rest follows the payment plan."
      },
      {
        "q": "What is a post-handover payment plan?",
        "a": "Some developers let you pay part of the price after you receive the keys, usually over a few years. Terms differ from project to project."
      },
      {
        "q": "Does buying property give me a UAE visa?",
        "a": "Property worth AED 2 million or more can make the owner eligible for the 10-year Golden Visa, subject to the rules in force when you apply."
      },
      {
        "q": "Can I sell before handover?",
        "a": "Often yes, through an assignment, once you have paid the minimum share the developer requires. Conditions and fees vary by project."
      }
    ],
    "note": "Fees and rules can change. We confirm the current figures for your project before you reserve.",
    "cta": {
      "title": "Ready to start?",
      "text": "Tell us your budget and preferred area, and we will shortlist the right projects and stay with you at every step.",
      "button": "Talk to an advisor"
    }
  },

  // عناوين ووصف الصفحات لجوجل ومحركات البحث
  seo: {
    org: "HELMAX Real Estate is a real estate agency in Business Bay, Dubai, specialising in off-plan property from developers such as Emaar, DAMAC, Sobha, Nakheel and Binghatti.",
    home: {
      title: "HELMAX Real Estate | Off-Plan Property in Dubai",
      description: "Buy off-plan property in Dubai with HELMAX Real Estate: new launches from Emaar, DAMAC, Sobha, Nakheel and more, with clear prices, payment plans and handover dates.",
    },
    about: {
      title: "About HELMAX Real Estate | Off-Plan Advisors in Dubai",
      description: "HELMAX Real Estate guides investors and families to Dubai's best off-plan projects, from verified developers to handover. Office in Business Bay, Dubai.",
    },
    projects: {
      title: "Off-Plan Projects in Dubai: Prices & Handover | HELMAX",
      description: "Compare {count} off-plan projects in Dubai from {devs} developers: starting prices in AED, handover dates and status. Filter by type, developer and area.",
    },
    blogs: {
      title: "Dubai Off-Plan Guides & Market Insights | HELMAX",
      description: "Practical guides on buying off-plan property in Dubai: payment plans, escrow, contracts, rental yields, mortgages for non-residents and more.",
    },
    contact: {
      title: "Contact HELMAX Real Estate | Business Bay, Dubai",
      description: "Talk to a HELMAX off-plan advisor by phone, WhatsApp or email. Office 1141, Tamani Arts Offices, Business Bay, Dubai. Open Mon–Sat, 12 PM–10 PM.",
    },
    developer: {
      title: "{name} Off-Plan Projects in Dubai | HELMAX",
      description: "{name} off-plan projects in Dubai: latest launches, starting prices and handover dates. Founded in {since}. Talk to a HELMAX advisor before you reserve.",
    },
    guide: {"title": "How to Buy Off-Plan Property in Dubai: Guide | HELMAX", "description": "Step-by-step guide to buying off-plan property in Dubai: reservation, SPA, Oqood registration, DLD fees, escrow protection, payment plans and handover."},
    home_crumb: "Home",
  },
};

export default en;
